import { Reveal } from "./Reveal";
import { apropos, profil } from "../../data/content";

export const About = () => (
  <section id="profil" className="relative py-24 md:py-32 border-t border-white/5">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
      {/* Left: heading + large portrait */}
      <div className="lg:col-span-5">
        <Reveal>
          <div className="flex items-center gap-4 mb-6">
            <span className="font-display text-cyan text-sm tracking-[0.3em]">01</span>
            <span className="h-px w-10 bg-cyan/40" />
            <span className="text-[11px] uppercase tracking-[0.35em] text-[var(--text-2)]">À propos</span>
          </div>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display font-medium text-4xl sm:text-5xl leading-[0.95] tracking-tight">
            Un profil <span className="font-serif-italic text-[var(--text-2)]">business</span> & technologique.
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <div className="mt-10 relative group">
            <div className="absolute -inset-4 bg-[radial-gradient(circle_at_50%_25%,rgba(0,229,255,0.2),transparent_70%)] blur-3xl opacity-60 group-hover:opacity-100 transition-opacity duration-700" />
            <div className="relative overflow-hidden rounded-3xl border border-white/10">
              <img
                src="/andrew.png"
                alt="Andrew Picornell, portrait professionnel"
                loading="lazy"
                className="w-full aspect-[3/4] object-cover object-top [filter:grayscale(0.2)] group-hover:[filter:grayscale(0)] group-hover:scale-[1.02] transition-[filter,transform] duration-700"
                data-testid="about-photo"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#05070A]/80 via-transparent to-transparent pointer-events-none" />
              <div className="absolute bottom-5 left-5 right-5 flex items-end justify-between">
                <div>
                  <p className="font-display text-xl text-white leading-tight">Andrew Picornell</p>
                  <p className="text-xs text-cyan tracking-wide mt-0.5">IMT-BS · Master 1</p>
                </div>
                <span className="text-[10px] uppercase tracking-[0.25em] text-white/60">Vitry-sur-Seine</span>
              </div>
            </div>
            <span className="absolute -top-2 -right-2 h-9 w-9 border-t-2 border-r-2 border-cyan/70 rounded-tr-lg" />
            <span className="absolute -bottom-2 -left-2 h-9 w-9 border-b-2 border-l-2 border-cyan/70 rounded-bl-lg" />
          </div>
        </Reveal>
      </div>

      {/* Right: narrative + facts */}
      <div className="lg:col-span-7">
        <Reveal delay={0.15}>
          <p className="font-display font-normal text-2xl md:text-3xl leading-snug tracking-tight text-white/95 mb-10">
            {apropos.intro}
          </p>
        </Reveal>
        <div className="grid md:grid-cols-2 gap-x-12 gap-y-6">
          {apropos.paragraphes.map((p, i) => (
            <Reveal key={i} delay={0.2 + i * 0.08}>
              <p className="text-[var(--text-2)] leading-relaxed">{p}</p>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.3}>
          <div className="mt-12 grid sm:grid-cols-2 gap-x-12 gap-y-4 text-sm text-[var(--text-2)] border-t border-white/5 pt-8">
            <div className="flex justify-between border-b border-white/5 pb-3"><span>École</span><span className="text-white text-right">IMT-BS</span></div>
            <div className="flex justify-between border-b border-white/5 pb-3"><span>Formation</span><span className="text-white text-right max-w-[65%]">{profil.formation}</span></div>
            <div className="flex justify-between border-b border-white/5 pb-3"><span>Majeure</span><span className="text-white text-right max-w-[65%]">{profil.majeure}</span></div>
            <div className="flex justify-between border-b border-white/5 pb-3"><span>Localisation</span><span className="text-white text-right">{profil.localisation}</span></div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
